import _ from "lodash";
import { api } from "api";
import uuidv1 from "uuid/v1";
import Swal from "sweetalert2";
import moment from "moment/moment";
import { ToastStore } from "react-toasts";
import { push } from "react-router-redux";
import { handleActions } from "redux-actions";
import { actions as printActions } from "../print/print";

// ------------------------------------
// Constants
// ------------------------------------
const endpoint = "despachos";
export const DATA = "DESPACHOS_DATA";
export const ITEM = "DESPACHOS_ITEM";
export const SORT = "DESPACHOS_SORT";
export const PAGE = "DESPACHOS_PAGE";
export const BUSCADOR = "DESPACHOS_BUSCADOR";
export const LOADER = "DESPACHOS_LOADER";
export const ESTADO = "DESPACHOS_ESTADO";
export const FECHA_INICIAL = "DESPACHOS_FECHA_INICIAL";
export const FECHA_FINAL = "DESPACHOS_FECHA_FINAL";
export const ESTADO_DESCARGA = "DESPACHOS_ESTADO_DESCARGA";

// ------------------------------------
// PureActions
// ------------------------------------

export const seData = (data) => ({
    type: DATA,
    data,
});

export const setLoader = (loader) => ({
    type: LOADER,
    loader,
});

export const setBuscador = (search) => ({
    type: BUSCADOR,
    search,
});

export const setSort = (ordering) => ({
    type: SORT,
    ordering,
});

export const setPage = (page) => ({
    type: PAGE,
    page,
});

export const setItem = (item) => ({
    type: ITEM,
    item,
});

export const setEstado = (estado_despacho) => ({
    type: ESTADO,
    estado_despacho,
});
export const setFechaInicial = (fecha_inicial) => ({
    type: FECHA_INICIAL,
    fecha_inicial,
});

export const setFechaFinal = (fecha_final) => ({
    type: FECHA_FINAL,
    fecha_final,
});
const setEstadoDescarga = (estado_descarga) => ({
    type: ESTADO_DESCARGA,
    estado_descarga,
});
// ------------------------------------
// Actions
// ------------------------------------
export const listar = (page = 1) => (dispatch, getStore) => {
    dispatch(setLoader(true));
    const store = getStore();
    const {
        ordering,
        search,
        estado_despacho,
        fecha_inicial,
        fecha_final,
    } = store.reporte_despachos;
    const params = {
        ordering,
        search,
        estado: estado_despacho,
        page,
        fecha_inicial,
        fecha_final,
    };
    api.get(`${endpoint}/reporte`, params)
        .catch((err) => {})
        .then((data) => {
            if (data) {
                dispatch(seData(data));
            }
            dispatch(setPage(page));
            dispatch(setLoader(false));
        });
};

export const sortChange = (sortName, sortOrder) => (dispatch, getStore) => {
    if (sortOrder === "asc") {
        dispatch(setSort(sortName));
    } else {
        dispatch(setSort(`-${sortName}`));
    }
    const store = getStore();
    const page = store.sucursal.page;
    dispatch(listar(page));
};

export const buscar = (search) => (dispatch) => {
    dispatch(setBuscador(search));
    dispatch(listar());
};

export const changeEstado = (estado) => (dispatch) => {
    dispatch(setEstado(estado));
    dispatch(listar());
};

const getDespacho = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${endpoint}/${id}`)
        .catch((err) => {})
        .then((data) => {
            if (data) {
                dispatch(setItem(data));
            }
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

const seleccionImpresion = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${endpoint}/${id}`)
        .catch((err) => {})
        .then((data) => {
            if (data) {
                dispatch(setItem(data));
                setTimeout(() => {
                    dispatch(
                        printActions.print("reporteDespachoReimpresionNota")
                    );
                });
            }
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

export const setFecha = (key, value) => (dispatch, getStore) => {
    const store = getStore();
    const reporte_despachos = store.reporte_despachos;
    if (key === "Inicial") {
        const fecha_inicial = new Date(value);
        const fecha_final = new Date(reporte_despachos.fecha_final);
        if (fecha_final >= fecha_inicial) dispatch(setFechaInicial(value));
    } else {
        const fecha_inicial = new Date(reporte_despachos.fecha_inicial);
        const fecha_final = new Date(value);
        if (fecha_final >= fecha_inicial) dispatch(setFechaFinal(value));
    }
    dispatch(listar());
};

export const descargarListado = () => (dispatch, getStore) => {
    const store = getStore();
    const {
        ordering,
        search,
        estado_despacho,
        fecha_inicial,
        fecha_final,
    } = store.reporte_despachos;
    const params = {
        ordering,
        estado: estado_despacho,
        fecha_inicial,
        fecha_final,
    };

    dispatch(setEstadoDescarga(true));
    api.get(`despachos/descargar_excel_reporte`, params)
        .catch((err) => {
            Swal(
                "¡Error al descargar!",
                "Ocurrió un error al descargar el archivo. Por favor intenté más tarde.",
                "error"
            );
            dispatch(setEstadoDescarga(false));
        })
        .then((data) => {
            if (data) {
                Swal(
                    "¡Descarga en proceso!",
                    "La descarga comenzará en un momento. Por favor no recargue la página hasta que se haya descargado el archivo",
                    "info"
                );
                dispatch(setEstadoDescarga(true));
                dispatch(esperarDescarga(data.id));
            }
        });
};

const esperarDescarga = (id) => (dispatch) => {
    let intervalPromise;

    //  VOLVER A HACER LA PETICIÓN PARA VERIFICAR QUE YA TERMINO LA DESCARGA

    function listener() {
        api.get("archivos/estado_descarga", { id })
            .catch((err) => {
                let msg =
                    "Ocurrió un error al descargar el archivo. Por favor intenta más tarde";
                if (err.estado) {
                    msg = err.observaciones;
                }
                dispatch(setEstadoDescarga(false));
                clearInterval(intervalPromise);
                Swal("Error al descargar!", msg, "error");
            })
            .then((resp) => {
                if (resp.estado === 10) {
                    // PROCESANDO
                    dispatch(setEstadoDescarga(true));
                } else if (resp.estado === 20) {
                    // TERMINADO
                    clearInterval(intervalPromise);
                    let nombre = resp.archivo
                        ? resp.archivo.split("/media/archivos/")[1]
                        : "Bajas_salidas_por_producto.xlsx";
                    const context = {
                        name: name,
                        url: resp.archivo,
                    };

                    dispatch(setEstadoDescarga(false));
                    dispatch(descargaArchivo(context));
                }
            });
    }

    listener();
    intervalPromise = setInterval(listener, 1000);
};

const descargaArchivo = (context) => (dispatch) => {
    let elem = document.createElement("a");
    elem.href = context.url;
    elem.download = context.name;
    elem.target = "hiddenIframe";
    elem.click();
    dispatch(setEstadoDescarga(false));
    ToastStore.success("Archivo descargado exitosamente");
};

export const actions = {
    sortChange,
    changeEstado,
    buscar,
    listar,
    getDespacho,
    setFecha,
    descargarListado,
    seleccionImpresion,
};

// ------------------------------------
// Reducers
// ------------------------------------

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [ITEM]: (state, { item }) => {
        return {
            ...state,
            item,
        };
    },
    [BUSCADOR]: (state, { search }) => {
        return {
            ...state,
            search,
        };
    },
    [PAGE]: (state, { page }) => {
        return {
            ...state,
            page,
        };
    },
    [SORT]: (state, { ordering }) => {
        return {
            ...state,
            ordering,
        };
    },
    [ESTADO]: (state, { estado_despacho }) => {
        return {
            ...state,
            estado_despacho,
        };
    },
    [FECHA_INICIAL]: (state, { fecha_inicial }) => {
        return {
            ...state,
            fecha_inicial,
        };
    },
    [FECHA_FINAL]: (state, { fecha_final }) => {
        return {
            ...state,
            fecha_final,
        };
    },
    [ESTADO_DESCARGA]: (state, { estado_descarga }) => {
        return {
            ...state,
            estado_descarga,
        };
    },
};

// ------------------------------------
// InitialState
// ------------------------------------

export const initialState = {
    data: {},
    item: null,
    loader: false,
    page: 1,
    search: "",
    ordering: "-creado",
    estado_despacho: 10,
    fecha_inicial: moment().format("YYYY-MM-DD"),
    fecha_final: moment().format("YYYY-MM-DD"),
    estado_descarga: false,
};

export default handleActions(reducers, initialState);
